import { DistrictListQueryParams, useDistrictListQuery } from '../queries';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { FormState } from 'react-hook-form';
import { Input } from '~/components/Input';

interface Props<TFormState extends BaseFormState> {
  onChange?: (values: number[]) => void;
  query?: DistrictListQueryParams;
  formState?: FormState<TFormState>;
  placeholder?: string;
  disabled?: boolean;
  value?: number[];
}

function DistrictMultiSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = { results: [] }, isLoading } = useDistrictListQuery(props.query);

  return (
    <Input.MultiSelect
      placeholder={props.placeholder ?? 'Välj en eller flera distrikt'}
      options={data.results.map(o => [o.name ?? '', o.id ?? 0])}
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      disabled={props.disabled || isLoading}
      aria-label="Sök distrikt"
      ref={ref}
      {...props}
    />
  );
}

export const DistrictMultiSelect = forwardRef(DistrictMultiSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof DistrictMultiSelectElement>;
